import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Clock, Music } from "lucide-react";

export default function Entertainers() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/entertainers")
      .then((r) => setItems(r.data))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <section id="entertainment" data-testid="entertainers-section" className="relative py-24 md:py-32 bg-neutral-900">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <p className="text-xs tracking-[0.3em] uppercase text-[#D4AF37] mb-4">This Week on Stage</p>
            <h2 className="font-serif font-light text-white text-4xl md:text-5xl lg:text-6xl tracking-tight">
              Nightly <span className="italic text-[#D4AF37]">entertainers</span>
            </h2>
          </div>
          <p className="text-neutral-400 max-w-md leading-relaxed">
            A rotating lineup of vocalists, trios and DJs — each curated to set the room's tempo from cocktail hour into the small hours.
          </p>
        </div>

        {loading ? (
          <div className="text-neutral-500" data-testid="entertainers-loading">Loading lineup…</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-neutral-800">
            {items.map((e, idx) => (
              <article
                key={e.id || idx}
                data-testid={`entertainer-card-${idx}`}
                className="group relative bg-neutral-950 p-8 md:p-10 hover:bg-neutral-900 transition-colors"
              >
                <div className="relative h-64 overflow-hidden mb-6">
                  <img
                    src={e.image_url}
                    alt={e.name}
                    className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-neutral-950 via-transparent to-transparent" />
                  <span className="absolute top-4 left-4 text-[10px] tracking-[0.3em] uppercase text-[#D4AF37] bg-black/60 backdrop-blur-md px-3 py-1.5">
                    {e.day_note || e.day}
                  </span>
                </div>
                <h3 className="font-serif text-2xl md:text-3xl text-white tracking-tight">{e.name}</h3>
                <div className="mt-3 flex items-center gap-2 text-neutral-400 text-sm">
                  <Music size={14} className="text-[#D4AF37]" />
                  <span>{e.genre}</span>
                </div>
                <div className="mt-2 flex items-center gap-2 text-neutral-400 text-sm">
                  <Clock size={14} className="text-[#D4AF37]" />
                  <span>{e.show_time}</span>
                </div>
                {e.bio && <p className="mt-5 text-neutral-400 leading-relaxed text-sm">{e.bio}</p>}
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
